import { createSelector } from 'reselect';

import { NAME } from './constants';

export const getModel = (state) => state[NAME];

export const getFetchItems = createSelector(
    getModel,
    (model) => model.fetchItems,
);
export const getIsFetchingItems = createSelector(
    getFetchItems,
    (model) => model.isFetching,
);
export const getFetchItemsData = createSelector(
    getFetchItems,
    (model) => model?.data?.data,
);
export const getFetchItemsPagination = createSelector(
    getFetchItems,
    (model) => model?.data?.pagination,
);

export const getIsOpenModal = createSelector(
    getModel,
    (model) => model.isOpenModal,
);

export const getPanelsIdsModel = createSelector(
    getModel,
    (model) => model.panelsIds,
);

export const getPanelsIdsData = createSelector(
    getPanelsIdsModel,
    (model) => model.data,
);

export const getFetchBrands = createSelector(
    getModel,
    (model) => model.fetchBrands,
);

export const getIsFetchingBrands = createSelector(
    getFetchBrands,
    (fetchBrands) => fetchBrands.isFetching,
);

export const getBrandsData = createSelector(
    getFetchBrands,
    (fetchBrands) => fetchBrands.data,
);
